import { IState } from "../../../reducer";
import { ICompleteOrganization } from "../../../types/common";

export const currentCompleteOrganization = (state: IState): ICompleteOrganization | null =>
  state.App.OrganizationSettings.organization;

export const currentCompleteOrganizationId = (state: IState): string | null =>
  state.App.OrganizationSettings.organization?.organizationId || null;
